const rootRouteId = "__root__";
export {
  rootRouteId
};
//# sourceMappingURL=root.js.map
